export default "__VITE_ASSET__ByK6W8$S__"